/**
 * Same as NumberFormatRFH but without react-hook-form control/register, using
 * value and onChange.
 */
import { NumericFormat } from 'react-number-format';

import H2 from '../Texts/H2';

type InputProps = {
  name: string;
  title?: string;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  prefix?: string;
  suffix?: string;
  editing?: boolean;
  isDisabled?: boolean;
  children?: JSX.Element | false | undefined;
  decimalScale?: number;
  onChange?: (value: string) => void;
  value?: string | number | null | undefined;
};

export const NumberFormatInput = ({
  name,
  title,
  placeholder,
  className,
  editing = true,
  prefix,
  suffix,
  children,
  decimalScale = 2,
  onChange,
  value,
}: InputProps) => {
  return (
    <div className={`flex  ${className || 'flex-col'}`}>
      {title && (
        <div className="">
          <H2 text={title} fontSize="16px" fontWeight={600} />
        </div>
      )}
      <div className="w-full">
        <NumericFormat
          name={name}
          value={value}
          thousandSeparator={true}
          thousandsGroupStyle="thousand"
          decimalScale={decimalScale}
          fixedDecimalScale
          prefix={prefix}
          suffix={suffix}
          onChange={(val: any) =>
            onChange &&
            onChange(val.target.value.replace(/["$",",","(",")","%"]/gi, ''))
          }
          onBlur={() => {}}
          onBlurCapture={() => {}}
          onChangeCapture={() => {}}
          onPointerLeave={() => {}}
          placeholder={placeholder}
          disabled={!editing}
          className={`border rounded-lg text-[#737588] w-full h-10 px-3  border-[#ced4da] outline-none focus:border-skyBlue`}
        />
        {/* You can pass a component to display stuff under the input. Its usually used for
                 displaying error msges */}
        {children && children}
      </div>
    </div>
  );
};
